import {
  QM,
  QUEUE_STATE,
  REPLY_OWED_CRITICAL_AFTER_SECONDS,
  STATE_LABEL,
} from './constants';

export {
  elapsedSince,
  fmtClock,
  fmtDateTimeLocal,
  fmtElapsed,
  istInputToEpoch,
  shortId,
  startOfIstToday,
} from './time';

const TONE = {
  warn: {
    bg: QM.BG_WARNING_1,
    ink: QM.TEXT_WARNING,
    border: QM.BORDER_WARNING,
  },
  errorHeavy: {
    bg: QM.BG_ERROR_HEAVY,
    ink: QM.TEXT_ERROR,
    border: QM.BORDER_ERROR,
    bold: true,
  },
  error: {
    bg: QM.BG_ERROR_1,
    ink: QM.TEXT_ERROR,
    border: QM.BORDER_ERROR,
  },
  info: { bg: QM.BG_INFO_1, ink: QM.TEXT_INFO, border: QM.BORDER_INFO },
  well: {
    bg: QM.BG_WELL,
    ink: QM.TEXT_SECONDARY,
    border: QM.BORDER_TERTIARY_SOFT,
  },
  success: {
    bg: QM.BG_SUCCESS_1,
    ink: QM.TEXT_SUCCESS,
    border: QM.BORDER_SUCCESS,
  },
};

export { TONE };

/**
 * The amber distribution: a reply owed reads amber until it has gone
 * unanswered long enough to be a problem, then it escalates to red. Quiet and
 * not-yet-spoken stay neutral so the two amber/red states are the only things
 * competing for attention.
 */
export const stateTone = (state, elapsedSeconds) => {
  if (state !== QUEUE_STATE.REPLY_OWED) return TONE.well;
  return elapsedSeconds >= REPLY_OWED_CRITICAL_AFTER_SECONDS
    ? TONE.errorHeavy
    : TONE.warn;
};

/**
 * Deliberately not a function of elapsed time. This used to escalate the
 * wording to AGENT SILENT past the threshold, which claimed a named person
 * was sitting on the ticket — impossible on two of the three panes, both
 * defined by `assigned_agent_id IS NULL`. Who holds the row is already the
 * pane heading and the Owner column; the pill says what is owed, its colour
 * says how bad, and the clock beside it says how long.
 */
export const stateLabel = state => STATE_LABEL[state] || '';
